import { CurrencyPipe, NgFor } from "@angular/common";
import { Component, Input } from "@angular/core";
import { BookingPrice } from "../../core/types/booking.types";

@Component({
    selector: "app-price-and-cargo",
    standalone: true,
    imports: [NgFor, CurrencyPipe],
    templateUrl: "./price-and-cargo.component.html",
    styleUrl: "./price-and-cargo.component.scss",
})
export class PriceAndCargoComponent {
    @Input() vehicles: string | undefined;
    @Input() transportType: string | undefined;
    @Input() bookingPrice: BookingPrice | undefined;

    cssLargeSizeCargo: string = "info-block__row__value-large-size";
    cssMediumSizeCargo: string = "info-block__row__value-medium-size";
    cssNormaSizeCargo: string = "info-block__row__value";

    maxSmallSizeCargoDetails: number = 3;
    maxMediumSizeCargoDetails: number = 6;

    get vehicleClassName(): string {
        if (!this.vehicles || this.vehicles.length === 0) {
            return this.cssNormaSizeCargo;
        }
        let cargoOppVehicleDetailsCssClass: string = this.vehicles.length > this.maxSmallSizeCargoDetails ? this.cssMediumSizeCargo : this.cssNormaSizeCargo;
        cargoOppVehicleDetailsCssClass = this.vehicles.length > this.maxMediumSizeCargoDetails ? this.cssLargeSizeCargo : this.cssMediumSizeCargo;
        return cargoOppVehicleDetailsCssClass;
    }
}
